import React from 'react';
import EsLogo from 'components/shared/icons/EsLogo';
import { Box, makeStyles } from '@material-ui/core';
import Link from 'components/shared/Link';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    // marginTop: theme.spacing(-2.5),
    // marginBottom: theme.spacing(1.25),
    // marginLeft: theme.spacing(-1.25),
  },
  esLogo: {
    height: 'auto',
    width: theme.spacing(16),
    verticalAlign: 'middle',
    display: 'inline-block',
    [theme.breakpoints.up('md')]: {
      height: 'auto',
      width: theme.spacing(25),
    },
  },
  // esTxt: {
  //   fontSize: theme.typography.pxToRem(22),
  //   lineHeight: theme.typography.pxToRem(42),
  //   verticalAlign: 'middle',
  //   display: 'inline-block',
  //   [theme.breakpoints.up('md')]: {
  //     fontSize: theme.typography.pxToRem(24),
  //   },
  // },
  logoLink: {
    display: 'inline-block',
  },
}));

const EsLogoFooter = () => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.logoContainer}>
        <Link
          href="/"
          className={classes.logoLink}
        >
          <EsLogo classes={{ root: classes.esLogo }} />
          {/* <Typography component="span" classes={{ root: classes.esTxt }}>
            eagle
            <b>share</b>
          </Typography> */}
        </Link>
      </Box>
    </>
  );
};

export default EsLogoFooter;
